import { StandardEvents } from '@shopify/events';
(() => {
  const drawer = document.getElementById('ca-cart-drawer');
  if (!drawer || typeof drawer.showModal !== 'function') return;
  const items = drawer.querySelector('[data-ca-cart-items]');
  const status = drawer.querySelector('[data-ca-cart-status]');
  const footer = drawer.querySelector('[data-ca-cart-foot]');
  const checkout = drawer.querySelector('[name="checkout"]');
  const root = (window.Shopify?.routes?.root || drawer.dataset.root || '/').replace(/\/?$/, '/');
  const escape = value => String(value ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  let busy = false, currency = 'EUR', previousOverflow = '', returnFocus = null;
  const money = cents => new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency',currency}).format(cents / 100);
  function setBusy(value) {
    busy = value;
    items.setAttribute('aria-busy', String(value));
    items.querySelectorAll('button').forEach(b => b.disabled = value);
    checkout.disabled = value;
  }
  async function request(path, options = {}) {
    const response = await fetch(root + path, {credentials:'same-origin',cache:'no-store',...options});
    const data = await response.json();
    if (!response.ok) throw new Error(data.description || data.message || 'Bitte versuche es erneut.');
    return data;
  }
  function show() {
    if (drawer.open) return;
    returnFocus = document.activeElement;
    previousOverflow = document.documentElement.style.overflow;
    drawer.showModal();
    document.documentElement.style.overflow = 'hidden';
  }
  drawer.addEventListener('close', () => {
    document.documentElement.style.overflow = previousOverflow;
    if (returnFocus?.isConnected) returnFocus.focus({preventScroll:true});
  });
  function render(cart) {
    currency = cart.currency || 'EUR';
    document.querySelectorAll('[data-ca-cart-count]').forEach(n => n.textContent = cart.item_count);
    footer.hidden = !cart.item_count;
    drawer.querySelector('[data-ca-cart-total]').textContent = money(cart.total_price);
    items.innerHTML = cart.items.length ? cart.items.map(item => {
      const properties = Object.entries(item.properties || {}).filter(([key,value]) => !key.startsWith('_') && value).map(([key,value]) => `<p class="ca-cart-property">${escape(key)}: ${escape(value)}</p>`).join('');
      const discounts = (item.line_level_discount_allocations || []).map(d => `<p class="ca-cart-discount">${escape(d.discount_application.title)} (−${escape(money(d.amount))})</p>`).join('');
      return `<article class="ca-cart-item" data-key="${escape(item.key)}">
        ${item.image ? `<img src="${escape(item.image)}" alt="${escape(item.featured_image?.alt || item.product_title)}" width="88" height="100">` : '<span></span>'}
        <div><a href="${escape(item.url)}">${escape(item.product_title)}</a>
        ${item.variant_title && item.variant_title !== 'Default Title' ? `<p class="ca-cart-variant">${escape(item.variant_title)}</p>` : ''}${properties}
        <p class="ca-cart-price">${item.original_line_price > item.final_line_price ? `<s>${escape(money(item.original_line_price))}</s>` : ''}${escape(money(item.final_line_price))}</p>${discounts}
        <div class="ca-cart-controls"><div class="ca-cart-quantity" role="group" aria-label="Menge für ${escape(item.product_title)}">
        <button type="button" data-ca-quantity="${item.quantity - 1}" aria-label="Menge verringern">−</button><span aria-label="Menge">${item.quantity}</span><button type="button" data-ca-quantity="${item.quantity + 1}" aria-label="Menge erhöhen">+</button></div>
        <button type="button" class="ca-cart-remove" data-ca-quantity="0">Entfernen</button></div></div></article>`;
    }).join('') : '<div class="ca-cart-empty"><p>Dein Warenkorb ist leer.</p><button type="button" data-ca-cart-close>Weiter einkaufen</button></div>';
  }
  async function refresh() { const cart = await request('cart.js'); render(cart); return cart; }
  document.addEventListener('click', async event => {
    const opener = event.target.closest('[data-ca-cart-open]');
    if (!opener || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0) return;
    event.preventDefault(); show();
    if (busy) return;
    setBusy(true); status.textContent = 'Warenkorb wird geladen …';
    try { await refresh(); status.textContent = ''; }
    catch { status.textContent = 'Der Warenkorb konnte nicht geladen werden. Bitte schließe ihn und versuche es erneut.'; }
    finally { setBusy(false); }
  });
  drawer.addEventListener('click', async event => {
    if (event.target === drawer || event.target.closest('[data-ca-cart-close]')) { drawer.close(); return; }
    const button = event.target.closest('[data-ca-quantity]');
    if (!button || busy) return;
    const row = button.closest('[data-key]'), key = row.dataset.key;
    const action = button.getAttribute('aria-label') || 'Entfernen';
    setBusy(true); status.textContent = 'Warenkorb wird aktualisiert …';
    try {
      render(await request('cart/change.js', {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({id:key,quantity:Number(button.dataset.caQuantity)})}));
      status.textContent = 'Warenkorb aktualisiert.';
    } catch(error) { status.textContent = error.message; }
    finally {
      setBusy(false);
      const newRow = Array.from(items.querySelectorAll('[data-key]')).find(r => r.dataset.key === key);
      (newRow?.querySelector(`[aria-label="${action}"]`) || drawer.querySelector('[data-ca-cart-close]')).focus({preventScroll:true});
    }
  });
  // Native theme form and Kaching own submission; this listener only opens the drawer.
  document.addEventListener(StandardEvents.cartLinesUpdate, async event => {
    if (event.action !== 'add' || !event.promise) return;
    try {
      const result = await event.promise;
      if (result?.detail?.didError) return;
      show(); setBusy(true); status.textContent = 'Warenkorb wird geladen …';
      await refresh(); status.textContent = 'Zum Warenkorb hinzugefügt.';
    } catch { if (drawer.open) status.textContent = 'Bitte öffne den Warenkorb erneut, um ihn zu aktualisieren.'; }
    finally { setBusy(false); }
  });
  function configureCartAction() {
    window.Shopify?.actions?.openCart?.configure({handler: async () => {
      show(); setBusy(true);
      try { await refresh(); status.textContent = ''; }
      catch { status.textContent = 'Bitte öffne den Warenkorb erneut, um ihn zu aktualisieren.'; }
      finally { setBusy(false); }
    }});
  }
  configureCartAction();
  document.addEventListener('DOMContentLoaded', configureCartAction, {once:true});
  function connectBundle(widget) {
    if (!widget || widget.dataset.caConnected) return;
    widget.dataset.caConnected = 'true';
    const update = () => {
      const lines = typeof widget.items === 'function' ? widget.items() : [];
      const gift = document.querySelector('.ca-gift-wrap');
      if (gift && lines.length) gift.hidden = !lines.some(line => [46325081571507,46325081604275].includes(Number(line.id)));
    };
    widget.addEventListener('items-changed', update); update();
  }
  document.addEventListener('kaching-bundles-block-loaded', event => connectBundle(event.detail?.component));
  document.querySelectorAll('kaching-bundles-block').forEach(connectBundle);
})();
